import type { LanguageCode } from "config/languages";
import languages from "config/languages";

export const getLocaleByLanguage = (language: LanguageCode) => {
  switch (language) {
    case "en-int":
      return "en-001";
    case "en-default":
      return "en-001";
    case "fr-default":
      return "fr-fr";
    case "de-default":
      return "de-de";
    default:
      return languages.get(language).hreflang;
  }
};
